import { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

export default function AssetRegisterList() {
  const COMPANY_CODE = localStorage?.getItem("companyCode") || "-";
  const [assets, setAssets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const navigate = useNavigate();

  // const COMPANY_CODE = localStorage?.getItem("companyCode") || "DOODDEMO";

  useEffect(() => {
    fetchAssets();
  }, []);

  const fetchAssets = async () => {
    try {
      let API_PATHS = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";

      const BASE_URL =
        API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";

      const res = await fetch(
        `${BASE_URL}/api/cpayscount/${COMPANY_CODE}/assetlist/-/-`,
      );
      const data = await res.json();
      setAssets(data);
    } catch (error) {
      console.error("API Error", error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (isoDateString) => {
    const date = new Date(isoDateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <div className="p-6">
      {/* Header */}
      <div className="sm:flex sm:items-center sm:justify-between mb-6">
        <div>
          <h1 className="text-xl font-semibold text-gray-900">
            Asset Catalogue
          </h1>
          <p className="mt-1 text-sm text-gray-500">
            List of all registered assets
          </p>
        </div>

        <button
          className="mt-4 sm:mt-0 inline-flex items-center rounded-md bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow hover:bg-indigo-700"
          onClick={() =>
            navigate("/register_asset", { state: { asset_object: null } })
          }
        >
          + Add New Asset
        </button>
      </div>

      {/* Table */}
      <div className="overflow-x-auto rounded-lg border border-gray-200">
        <table className="min-w-full divide-y divide-gray-200 text-sm">
          <thead className="bg-gray-50">
            <tr>
              {[
                "Asset No",
                "Reg Date",
                "Barcode",
                "Category",
                "Asset Name",
                "Short Name",
                "Custodian",
                "Purchased On",
                "Supplier",
                "Purchase Value",
                "Salvage Value",
                "Voucher No",
                "DEPR MONTHS",
                "DEPR OPENING",
              ].map((head) => (
                <th
                  key={head}
                  className="px-4 py-3 text-left font-medium text-gray-500 uppercase tracking-wide"
                >
                  {head}
                </th>
              ))}
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-100 bg-white">
            {loading ? (
              <tr>
                <td colSpan="12" className="text-center py-6 text-gray-500">
                  Loading...
                </td>
              </tr>
            ) : (
              assets.map((asset, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-4 py-2">
                    {asset.ASSET_NO}
                    <button
                      onClick={() =>
                        navigate("/register_asset", {
                          state: { asset_object: asset },
                        })
                      }
                      className="text-indigo-600 hover:text-indigo-900 font-medium"
                    >
                      Edit
                    </button>
                  </td>
                  <td className="px-4 py-2">{formatDate(asset.REGDATE)}</td>
                  <td className="px-4 py-2">{asset.BARCODE}</td>
                  <td className="px-4 py-2">{asset.CATEGORY}</td>
                  <td className="px-4 py-2 font-medium text-gray-900">
                    {asset["ASSET NAME"]}
                  </td>
                  <td className="px-4 py-2">{asset["SHORT NAME"]}</td>
                  <td className="px-4 py-2">{asset.CUSTODIAN}</td>
                  <td className="px-4 py-2">
                    {formatDate(asset.PURCHASED_ON)}
                  </td>
                  <td className="px-4 py-2">{asset.SUPPLIER}</td>
                  <td className="px-4 py-2">{asset.PURCH_VALUE}</td>
                  <td className="px-4 py-2">{asset["SALVAGE-VALUE"]}</td>

                  <td className="px-4 py-2">{asset.VOUCHER_NO}</td>
                  <td className="px-4 py-2">{asset.DEPR_MONTHS}</td>
                  <td className="px-4 py-2">{asset.DEPR_OPENING}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* DETAILS MODAL */}
      {selectedAsset && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-lg shadow-xl max-w-lg w-full p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              Asset Details
            </h3>

            <div className="grid grid-cols-2 gap-4 text-sm">
              {Object.entries(selectedAsset).map(([key, value]) => (
                <div key={key}>
                  <p className="text-gray-500 capitalize">{key}</p>
                  <p className="font-medium text-gray-900">{value}</p>
                </div>
              ))}
            </div>

            <div className="mt-6 flex justify-end">
              <button
                onClick={() => setSelectedAsset(null)}
                className="rounded-md bg-gray-100 px-4 py-2 text-sm font-medium hover:bg-gray-200"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
